import * as React from "react"
import * as Models from "./models"

export function useOptions<T, V extends Models.ItemValue>(options: Models.Props<T, V>["options"]) {
    return React.useMemo(() => {
        if (!options || options.length === 0)
            return [];

        if (typeof (options[0]) == "string")
            return (options as string[]).map<Models.Option<any, any>>(x => ({ itemValue: x, itemText: x, data: x as any }))

        return options as Models.Option<any, any>[];
    }, [options]);
}

export function useWindowSize() {
    const [windowSize, setWindowSize] = React.useState({
      width: undefined,
      height: undefined,
    });
  
    React.useEffect(() => {
      function handleResize() {
        setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight,
        });
      }
      
      window.addEventListener("resize", handleResize);
      handleResize();
      
      return () => window.removeEventListener("resize", handleResize);
    }, [])

    return windowSize;
  }